import CpGetStarted from "@/components/communityPortal/home/CpGetStarted";
import NotFound from "@/components/common/NotFound";
import { isCommunityPortal } from "@/utils/type";

const GetStarted = ({ type }) => {
    return isCommunityPortal(type) ? <CpGetStarted /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default GetStarted;
